export const KEY_NAME_VALIDATION_ERRORS = {
  zdbplt3id0mnh: "Another key is already using the name",
} as const;

const SQL_VALIDATION_ERRORS = {
  ...KEY_NAME_VALIDATION_ERRORS,
  // Essential information
  a192d1119499: "The charset introduced is not valid",
  be9pf390snb8r: "Port is inaccessible",
  pu4qrccynugwl: "Database does not exist",
  ehcdcsbbtt1r8: "Invalid dialect",
  tcqi2y2umqe0l: "Invalid charset",
  ua9jup6rrxp30: "Port is inaccessible",
  x7tyewholaezl: "Required field for a SQL connection",
  "0vkhx9xky8ve6": "Incorrect user, password or database",
  "772t082yfgfl5": "Incorrect user or password",
  "8kt8obejs7l9g": "Unknown host",
  // SSH
  yj1ex7kpqker7: "Incorrect RSA Key",
  y2zfe0ata6gup: "Malformed RSA key",
  avq25xsd3kys0: "The RSA key is encrypted, so its passphrase is required",
  upzl3oepr60fr: "Incorrect passphrase for the RSA key",
  qji75e880n297: "Required field for a SSL connection",
  lpzhur1yvl6j9: "Either password or RSA key must be defined",
  "8baiqp2uycnfh": "Required field for a SSH connection",
  "1bcgajl9l2k16": "Cannot define both password and RSA key",
  // SSL
  wlxhc3u8jveb8: "SSL hostname mismatch",
  onsary2wlt12g: "SSL certificate expired",
  uve3mnizbhjwa: "SSL certificate not yet valid",
  kw9djxoj1plb6: "Invalid client certificate",
  zdnloxjjlbbof: "Invalid server CA certificate",
  yrthwc2d5c6kq: "Invalid client key",
  "4azx266vnkzch": "SSL certificate failed verification",
  "263apn1z0zvt3": "Invalid server CA certificate: not an RSA key",
  "558obzf0viygt": "Certificate verification failed",
} as const;

export const SQL_GENERIC_ERRORS = {
  kc7tujwr6la07: "There was a problem with the SSH tunnel",
  "7mdasgufeitfe": "Connection timed out for these settings",
  "5eipqn057vb8g": "There was a problem creating the credential",
  "4uibgd0t6517w": "There was a problem with the SSH tunnel",
} as const;

// For lookups by a type id from the API. Callers guard with `in`, which keeps these total.
export const KEY_NAME_VALIDATION_ERRORS_BY_ID: Record<string, string> = KEY_NAME_VALIDATION_ERRORS;
export const SQL_VALIDATION_ERRORS_BY_ID: Record<string, string> = SQL_VALIDATION_ERRORS;
export const SQL_GENERIC_ERRORS_BY_ID: Record<string, string> = SQL_GENERIC_ERRORS;
